import React from 'react'
import {
	BarLoader,
	BeatLoader,
	BounceLoader,
	CircleLoader,
	ClimbingBoxLoader,
	ClipLoader,
	ClockLoader,
	DotLoader,
	FadeLoader,
	GridLoader,
	HashLoader,
	MoonLoader,
	PacmanLoader,
	PropagateLoader,
	PulseLoader,
	PuffLoader,
	RingLoader,
	RiseLoader,
	RotateLoader,
	ScaleLoader,
	SkewLoader,
	SquareLoader,
	SyncLoader
} from 'react-spinners'


const Loader = props => {

	const {
		className,
		color,
		height,
		name,
		loading,
		radius,
		size,
		width
	} = props

	if (name==="BarLoader") {
		return (
			<div className={className}>
				<BarLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="BeatLoader") {
		return (
			<div className={className}>
				<BeatLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="BounceLoader") {
		return (
			<div className={className}>
				<BounceLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="CircleLoader") {
		return (
			<div className={className}>
				<CircleLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="ClimbingBoxLoader") {
		return (
			<div className={className}>
				<ClimbingBoxLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="ClimbingBoxLoader") {
		return (
			<div className={className}>
				<ClimbingBoxLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="ClipLoader") {
		return (
			<div className={className}>
				<ClipLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="ClockLoader") {
		return (
			<div className={className}>
				<ClockLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="DotLoader") {
		return (
			<div className={className}>
				<DotLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="FadeLoader") {
		return (
			<div className={className}>
				<FadeLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="GridLoader") {
		return (
			<div className={className}>
				<GridLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="HashLoader") {
		return (
			<div className={className}>
				<HashLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="MoonLoader") {
		return (
			<div className={className}>
				<MoonLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="PacmanLoader") {
		return (
			<div className={className}>
				<PacmanLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="PropagateLoader") {
		return (
			<div className={className}>
				<PropagateLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="PulseLoader") {
		return (
			<div className={className}>
				<PulseLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="PuffLoader") {
		return (
			<div className={className}>
				<PuffLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="RingLoader") {
		return (
			<div className={className}>
				<RingLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="RiseLoader") {
		return (
			<div className={className}>
				<RiseLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="RotateLoader") {
		return (
			<div className={className}>
				<RotateLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="ScaleLoader") {
		return (
			<div className={className}>
				<ScaleLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="SkewLoader") {
		return (
			<div className={className}>
				<SkewLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="SquareLoader") {
		return (
			<div className={className}>
				<SquareLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else if (name==="SyncLoader") {
		return (
			<div className={className}>
				<SyncLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}
	else {
		return (
			<div className={className}>
				<BarLoader
					width={width}
					height={height}
					size={size}
					radius={radius}
					color={color}
					loading={loading}
				/>
			</div>
		)
	}

}


export default Loader
